<div class="modal-header">
  <h5 class="modal-title">{{data.title}}</h5>
  <button (click)="close()" type="button" class="close">
    <span><i class="fal fa-times"></i></span>
  </button>
</div>
<div class="modal-body">
  <p [innerHtml]="data.body"></p>
</div>
